import { Environment } from "./Environment";
import { CampaignType, FormatType, ICampaign } from "@models";

export class PreviewHelper {

    public static getPreviewPath(previewPath: string, campaign: ICampaign, formatType: FormatType): string {
        let format = '';

        switch (campaign.type) {
            case CampaignType.generic_format:
            case CampaignType.hosting:
                if (formatType === FormatType.CANVAS || formatType === FormatType.CANVAS_MOBILE) {
                    format = 'pv';
                } else {
                    format = 'hosting';
                }
                break;
            case CampaignType.mobil_interscroll:
            case CampaignType.html_interscroll:
            case CampaignType.vertical_video_interscroll:
                format = 'interscroll';
                break;
            case CampaignType.desktop_interscroll:
            case CampaignType.desktop_fullscreen_interscroll:
            case CampaignType.desktop_html_interscroll:
            case CampaignType.video_desktop_interscroll:
                format = 'desktopinterscroll';
                break;
            case CampaignType.topscroll_desktop_video:
            case CampaignType.topscroll_desktop_html:
            case CampaignType.topscroll_desktop_image:
            case CampaignType.fullpage_overlay_desktop_html:
                format = 'topscroll';
                break;
            case CampaignType.html_topscroll:
            case CampaignType.topscroll:
            case CampaignType.video_topscroll:
            case CampaignType.fullpage_overlay_mobile_html:
                format = 'topscrollmobile';
                break;
            case CampaignType.inread_expander:
                format = 'inreadexpander';
                break;
            default:
                format = 'skin';
                break
        }

        let result = previewPath + format + '?guid=' + campaign.creativeCode;

        return result;
    }
}
